<template>
  <span v-if="cartCount" class="counter leading-none absolute bottom-0 left-0 -mb-2 -ml-2 p-1 text-xs text-white bg-primary-600 rounded-full flex justify-center items-center">
    {{ cartCount }}
  </span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppCartCounter',
  computed: {
    ...mapGetters('cart', [
      'cartCount'
    ])
  }
}
</script>
<style>
  .counter{
    min-width: 20px;
  }
</style>
